// 微信sdk依赖
import * as ShareApi from "@/api/share"

import axios from "axios"

const http = axios.create()
export function authorize(redirectUri) {
    // 微信授权登录
    let redirect_uri = redirectUri ? encodeURIComponent(redirectUri) : encodeURIComponent(location.location.href)
    ShareApi.getSignature({
        url: location.href.split("#")[0]
    }).then((data) => {
        // https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2606a047f43f3649&redirect_uri=https%3A%2F%2Fchong.qq.com%2Fphp%2Findex.php%3Fd%3D%26c%3DwxAdapter%26m%3DmobileDeal%26showwxpaytitle%3D1%26vb2ctag%3D4_2030_5_1194_60&response_type=code&scope=snsapi_base&state=123#wechat_redirect
        let wx_url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + data.appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect"
        // let info = {
        //     appid: data.appid,
        //     secret: data.secret
        // }
        // localStorage.setItem("wechat_auth", JSON.stringify(info))
        location.href = wx_url
    }).catch((e) => {
        console.log(e.msg || e.message);
    })
}

export function getAccessTokenInfo(code) {
    let info = JSON.parse(localStorage.getItem("wechat_auth"))
    if (info) {
        let url = "https://api.weixin.qq.com/sns/oauth2/access_token?appid=" + info.appid + "&secret=" + info.secret + "&code=" + code + "&grant_type=authorization_code"
        http({
            url: url,
            method: "GET",
            headers: { "content-type": "application/x-www-form-urlencoded" },
            // data: qs.stringify(data)
        })
            .then((response) => {
                // this._showToast("异步通知成功")
                // this.redirect(data)
                console.log('AccessToken response == %O', response);
                // localStorage.removeItem("wechat_auth")
            })
            .catch((err) => {
                console.log(err)
                // this._showToast("异步通知失败")
                // this.redirect(data)
            })
    }
}